import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableGridComponent } from './table-grid.component';
import { TableColumnPanelComponent } from './column-panel/column-panel.component';
import { SharedModule } from '../../../shared/shared.module';

@NgModule({
  declarations: [TableGridComponent, TableColumnPanelComponent],
  exports: [TableGridComponent, TableColumnPanelComponent],
  imports: [CommonModule, SharedModule],
})
export class TableGridModule {}
